type StackOverviewPromptArguments = {
  stackId: string;
};

export const buildStackOverviewPrompt = ({ stackId }: StackOverviewPromptArguments): string =>
  `Give me a quick overview of Spacelift stack \`${stackId}\`: its current state including any drift or active lock, the outcome of the last 5 runs with the reason for any failure, and anything that needs my attention right now.`;

export const STACK_CREATION_PROMPT =
  "Help me create a new Spacelift stack. Walk me through what you need — repository, branch, project root, vendor and workflow — and create the stack once we have the details.";
